import React from 'react';
import { useParams } from 'react-router-dom';

export default function EpisodePage() {
  const { slug } = useParams();
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold mb-2">Episode Detail</h1>
      <p className="text-slate-600 mb-6">Slug: {slug}</p>
      <div className="p-6 bg-slate-100 rounded-lg border border-slate-200">
        <p className="font-mono text-sm text-slate-500">Spec: 05_episode_page.md</p>
      </div>
    </div>
  );
}
